export class RegistrationRequest {
  email: string;
  password: string;
  confirmation: string;


  constructor(email: string, password: string, confirmation: string) {
    this.email = email;
    this.password = password;
    this.confirmation = confirmation;
  }
}
